import styled from '@emotion/styled';

export const SectionCashbackRequestsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

export const CashbackRequestsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: ${({theme}) => theme.gap.desktop.lg};
  width: 100%;

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    gap: ${({theme}) => theme.gap.desktop.md};
  }
`;
